import {ModalSize} from '../ui/modalSize.enum';

export interface CmElement {
  id: string;
  label?: string;
  placeholder?: string;
  error?: string;
  hint?: string;
  helpId?: string;
  tooltip?: string;
  tags?: string;
}

export interface CmMhsElement extends CmElement {
  dataType: string
  fieldType: string
  validators: string
}

export interface CmSection {
  id: string;
  title?: string;
  heading?: string;
  body?: string;
  helpId?: string;
  tags?: string;
}

export interface CmQuestion {
  id: string;
  question?: string;
  answer?: string;
  weight?: number;
  tags?: string;
}

export interface  CmQuestionGroup {
  id: string;
  title?: string;
  body?: string;
  questionList: string;
  tags?: string;
}

export interface  CmHelp {
  id: string;
  title?: string;
  body?: string;
  size?: string;
  closeLabel?: string;
  tags?: string;
  icon?: string; // does this really belong here. referenced from contact-us and fails prod build
}

export interface  CmTooltip {
  id?: string;
  title?: string;
  plainText?: string;

  'tooltip-id': string;
  'tooltip-title': string;
  'tooltip-text': string;
  'tooltip-plain-text': string;
  'tooltip-icon': string;
}

export interface  CmModal {
  modalId: string;
  modalHeader?: string;
  modalBody?: string;
  modalSize?: ModalSize;
}

// Enums =========
export enum ContentType {
  SECTION = 'section',
  ELEMENT = 'element',
  HELP = 'help',
  MODAL = 'modal',
  QUESTION = 'question',
  QUESTION_GROUP = 'question-group',
  TOOLTIP = 'tooltip'
}


// TODO OLD used by components where drupal calls will be removed. --------------
export interface ManagedContentModel {
  id: string;
  title: string;
  content: string;
  label: string;
  error: string;
}
// TODO  OLD used by components where drupal calls will be removed. --------------
export interface CmContentSpot {
  id: string;
  title: string;
  content: string;
  tags: string;
}
